const translationsObject = {
  en: require('./translations.json'),
  th: require('./translations_th.json'),
}

export default translationsObject
